
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/start-here/about-komodo-platform",
      function () {
        return require("private-next-pages/en/docs/start-here/about-komodo-platform/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/start-here/about-komodo-platform"])
      });
    }
  